import { HexColorInput } from 'react-colorful';

export const darkBarColours: string[] = [
  '#00122B',
  '#8A4B2A',
  '#1C5A54',
  '#0D3B66',
  '#3A4750',
  '#8A3A54',
  '#B1DFF6',
  '#FBDBC5',
  '#F7C2D5',
  '#FFFFFF',
];

export const navBarColours: string[] = [
  '#FFFFFF',
  '#FBDBC5',
  '#FFE9B5',
  '#E2F1EB',
  '#D2E9E0',
  '#DFF1FB',
  '#B1DFF6',
  '#E4E9ED',
  '#F7C2D5',
  '#FBDDE5',
];

const isColourDark = (hex: string): boolean => {
  const value = hex.replace('#', '');
  const r = parseInt(value.substring(0, 2), 16);
  const g = parseInt(value.substring(2, 4), 16);
  const b = parseInt(value.substring(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 < 128;
};

interface UploadHubColourPickerProps {
  color: string;
  setColor: (color: string) => void;
  colours?: string[];
}

const UploadHubColourPicker = ({ color, setColor, colours = navBarColours }: UploadHubColourPickerProps) => (
  <div className='d-flex flex-wrap ' style={{ maxWidth: '252px' }}>
    {colours.map((item: string) => {
      const isSelected = item.toLowerCase() === color?.toLowerCase();
      const isDark = isColourDark(item);
      return (
        <button
          key={item}
          type='button'
          className={`general-button specific-right-margin-6 specific-bottom-margin-6 rounded ${isSelected && isDark ? 'data-hub-picker-selected' : ''}`}
          style={{
            width: '30px',
            height: '30px',
            backgroundColor: item,
            border: isSelected
              ? `1px solid ${isDark ? item : '#00122B'}`
              : item === '#FFFFFF'
                ? '1px solid #E4E9ED'
                : '2px solid transparent',
          }}
          onClick={() => setColor(item)}
          aria-label={`Set color to ${item}`}
          aria-pressed={isSelected}
        />
      );
    })}
    <div className='d-flex color-picker-hex-color-input specific-right-margin-6'>
      <span className='text-main-blue-35 d-inline-block d-flex align-items-center justify-content-center'>
        <span>#</span>
      </span>
      <HexColorInput
        color={color}
        onChange={setColor}
        prefixed
        className='border rounded px-2 specific-y-padding-3 w-100'
        style={{ fontSize: '14px' }}
      />
    </div>
  </div>
);

export default UploadHubColourPicker;
